export default __webpack_public_path__ + "static/media/undraw_financial_data_re_p0fl.69aed44b.png";